<app-side-menu>
  <div class="b2b-contracts-view-container">
    <!-- Loading State -->
    <app-loading [show]="isLoading" message="Carregando contrato..."></app-loading>

    <!-- Content -->
    <div *ngIf="!isLoading && contract" class="view-content">
      <!-- Header -->
      <div class="header">
        <div class="title-section">
          <button class="btn-back" (click)="navigateBack()">
            <i class="fas fa-arrow-left"></i>
          </button>
          <div class="title-info">
            <h1>
              <i class="fas fa-file-contract me-2"></i>
              {{ contract?.contractName || 'Contrato B2B' }}
            </h1>
            <p>{{ contract?.contractNumber }}</p>
          </div>
        </div>
        <div class="action-buttons">
          <app-button
            text="Editar"
            color="var(--primary-color)"
            height="40px"
            (buttonClick)="navigateToEdit()">
            <i class="fas fa-edit me-2"></i>
          </app-button>
          <app-button
            *ngIf="canCancelB2bContract()"
            text="Cancelar"
            color="var(--danger-color)"
            height="40px"
            (buttonClick)="openCancelContractModal()">
            <i class="fas fa-ban me-2"></i>
          </app-button>
          <app-button
            text="Voltar"
            color="#64748b"
            height="40px"
            (buttonClick)="navigateBack()">
            <i class="fas fa-arrow-left me-2"></i>
          </app-button>
        </div>
      </div>

      <!-- Menu gerencial -->
      <div class="card mb-4 section-management-menu" id="menu-gerencial">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-th-large me-2"></i>
            Menu gerencial
          </h3>
        </div>
        <div class="card-body">
          <p class="text-muted mb-3">Acesso rápido a todas as áreas e funcionalidades deste contrato.</p>

          <div class="mgmt-group" *ngFor="let group of managementMenu">
            <div class="mgmt-group-title">{{ group.title }}</div>
            <div class="mgmt-actions">
              <button
                type="button"
                *ngFor="let item of group.items"
                class="btn mgmt-btn"
                [attr.data-tone]="item.tone"
                [class.mgmt-btn-primary]="item.primary"
                (click)="onManagementAction(item)">
                <i [class]="item.icon"></i>
                <span>{{ item.label }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Informações do contrato e empresa -->
      <div class="card mb-4 section-contract-general section-company-info" id="detalhes-contrato">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-file-alt me-2"></i>
            Detalhes do Contrato e Empresa
          </h3>
        </div>
        <div class="card-body contract-details-body">
          <div class="contract-details-grid">
            <div class="contract-detail-item">
              <label class="form-label">Cliente</label>
              <p class="form-control-plaintext">{{ contract?.customerName || contract?.companyName || 'N/A' }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">Data de Início</label>
              <p class="form-control-plaintext">{{ formatDate(contract?.startDate) }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">Data de Término</label>
              <p class="form-control-plaintext">{{ formatDate(contract?.endDate) }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">Data de Criação</label>
              <p class="form-control-plaintext">{{ formatDateTime(contract?.createdAt) }}</p>
            </div>
          </div>

          <div class="contract-details-divider"></div>

          <div class="contract-details-grid">
            <div class="contract-detail-item">
              <label class="form-label">Razão Social</label>
              <p class="form-control-plaintext">{{ contract?.companyName || 'N/A' }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">CNPJ</label>
              <p class="form-control-plaintext">{{ formatCnpj(contract?.cnpj) }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">Última Atualização</label>
              <p class="form-control-plaintext">{{ formatDateTime(contract?.updatedAt) }}</p>
            </div>
            <div class="contract-detail-item">
              <label class="form-label">Status</label>
              <p class="form-control-plaintext">
                <span *ngIf="contract?.status" [class]="'badge ' + getStatusBadgeClass(contract?.status)">
                  {{ getStatusLabel(contract?.status) }}
                </span>
                <span *ngIf="!contract?.status" class="text-muted">-</span>
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- Seção de Atribuição de Condutores -->
      <div class="card mb-4 border-warning section-driver-assignment" id="atribuir-condutor">
        <div class="card-header bg-warning text-dark">
          <h3 class="mb-0">
            <i class="fas fa-users-cog me-2"></i>
            Atribuição de Condutores
          </h3>
        </div>
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-8">
              <h5 class="mb-2">
                <i class="fas fa-link me-2 text-primary"></i>
                Central de Atribuição de Condutores
              </h5>
              <p class="text-muted mb-0">
                Gerencie a atribuição de condutores aos veículos dos itens do contrato. 
                Vincule condutores aos veículos, visualize associações existentes e gerencie as atribuições de forma centralizada.
              </p>
            </div>
            <div class="col-md-4 text-end">
              <button 
                class="btn btn-warning btn-lg" 
                (click)="navigateToDriverAssignment()"
                id="btn-atribuir-condutor">
                <i class="fas fa-users-cog me-2"></i>
                Acessar Central de Controle
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Resumo do Contrato -->
      <div class="row mb-4 section-contract-summary">
        <div class="col-md-4">
          <div class="card border-primary summary-card-clickable" role="button" (click)="navigateToItemsList()" title="Abrir somente a tabela de pedidos">
            <div class="card-body text-center">
              <h5 class="card-title text-primary">
                <i class="fas fa-list me-2"></i>
                Pedidos do Contrato
              </h5>
              <h2 class="mb-0">{{ totalItems || (contract?.contractItems || []).length }}</h2>
              <small class="text-muted">Clique para abrir a lista completa</small>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card border-success summary-card-clickable" role="button" (click)="navigateToDriversList()" title="Abrir somente a tabela de condutores">
            <div class="card-body text-center">
              <h5 class="card-title text-success">
                <i class="fas fa-users me-2"></i>
                Condutores
              </h5>
              <h2 class="mb-0">{{ getTotalDriversDisplay() }}</h2>
              <small class="text-muted">Clique para abrir a lista completa</small>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card border-info summary-card-clickable" role="button" (click)="navigateToVehiclesList()" title="Abrir somente a tabela de veículos">
            <div class="card-body text-center">
              <h5 class="card-title text-info">
                <i class="fas fa-motorcycle me-2"></i>
                Veículos
              </h5>
              <h2 class="mb-0">
                {{ getTotalVehicles() }}
              </h2>
              <small class="text-muted">Clique para abrir a lista completa</small>
            </div>
          </div>
        </div>
      </div>

      <!-- Frota do contrato (paginada) -->
      <div class="card mb-4 section-vehicles-management" id="frota-contrato">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <div>
              <h5 class="mb-1">
                <i class="fas fa-motorcycle me-2 text-info"></i>
                Frota do Contrato
              </h5>
              <p class="text-muted mb-0 small">Prévia paginada. Para focar só nesta tabela, abra a tela completa.</p>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <app-button
                text="Abrir tabela de veículos"
                color="var(--primary-color)"
                height="40px"
                (buttonClick)="navigateToVehiclesList()">
                <i class="fas fa-table me-2"></i>
              </app-button>
            </div>
          </div>
          <div *ngIf="totalVehicles > 0 || isLoadingVehicles || vehiclesSearchTerm || (vehicles && vehicles.length > 0); else emptyVehicles">
            <app-table
              [title]="'Frota do Contrato (' + totalVehicles + ')'"
              [data]="vehicles"
              [columns]="vehicleColumns"
              [loading]="isLoadingVehicles"
              [clickable]="false"
              [actions]="vehicleActions"
              [showSearch]="true"
              [searchPlaceholder]="'Pesquisar placa, marca, modelo, rastreador ou pedido...'"
              [itemsPerPage]="vehiclesPageSize"
              [totalItemsFromBackend]="totalVehicles"
              [currentPageFromBackend]="vehiclesPage"
              [totalPagesFromBackend]="vehiclesTotalPages"
              [disablePagination]="false"
              (searchChange)="onVehiclesSearchChange($event)"
              (actionClick)="onVehicleActionClick($event)"
              (pageChange)="onVehiclesPageChange($event)"
              (pageSizeChange)="onVehiclesPageSizeChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="totalVehicles === 0"
                (buttonClick)="exportVehiclesExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
          </div>

          <ng-template #emptyVehicles>
            <div class="empty-state text-center py-4">
              <i class="fas fa-motorcycle fa-2x text-muted mb-2"></i>
              <h5>Nenhum veículo na frota</h5>
              <p class="text-muted mb-0">Os veículos aparecem aqui após vincular snapshots aos pedidos do contrato.</p>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Painel de Condutores (atalhos para cadastro e listagem) -->
      <div class="card mb-4 section-drivers-management" id="condutores-contrato">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <div>
              <h5 class="mb-1">
                <i class="fas fa-users me-2 text-success"></i>
                Condutores do Contrato
              </h5>
              <p class="text-muted mb-0 small">Prévia paginada. Para focar só nesta tabela, abra a tela completa.</p>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <app-button
                text="Abrir tabela de condutores"
                color="var(--primary-color)"
                height="40px"
                (buttonClick)="navigateToDriversList()">
                <i class="fas fa-table me-2"></i>
              </app-button>
              <app-button
                text="Novo Condutor"
                color="var(--success-color)"
                height="40px"
                (buttonClick)="navigateToNewDriver()">
                <i class="fas fa-user-plus me-2"></i>
              </app-button>
            </div>
          </div>

          <div *ngIf="totalDrivers > 0 || isLoadingDrivers || driversSearchTerm || (drivers && drivers.length > 0); else emptyDrivers">
            <app-table
              [title]="'Gestão de Condutores (' + totalDrivers + ')'"
              [data]="drivers"
              [columns]="driverColumns"
              [loading]="isLoadingDrivers"
              [clickable]="false"
              [actions]="driverActions"
              [showSearch]="true"
              [searchRight]="true"
              [searchPlaceholder]="'Pesquisar nome, CPF, CNH ou matrícula...'"
              [itemsPerPage]="driversPageSize"
              [totalItemsFromBackend]="totalDrivers"
              [currentPageFromBackend]="driversPage"
              [totalPagesFromBackend]="driversTotalPages"
              [disablePagination]="false"
              (searchChange)="onDriversSearchChange($event)"
              (actionClick)="onDriverActionClick($event)"
              (pageChange)="onDriversPageChange($event)"
              (pageSizeChange)="onDriversPageSizeChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="totalDrivers === 0"
                (buttonClick)="exportDriversExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
          </div>

          <ng-template #emptyDrivers>
            <div class="empty-state text-center py-4">
              <i class="fas fa-users fa-2x text-muted mb-2"></i>
              <h5>Nenhum condutor cadastrado</h5>
              <p class="text-muted mb-2">Cadastre o primeiro condutor para este contrato.</p>
              <app-button
                text="Novo Condutor"
                color="var(--success-color)"
                height="40px"
                (buttonClick)="navigateToNewDriver()">
                <i class="fas fa-user-plus me-2"></i>
              </app-button>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Operacional B2B -->
      <div class="card mb-4 section-operational-b2b" id="operacional-contrato" *ngIf="contractId">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-clipboard-list me-2"></i>
            Operacional
          </h3>
        </div>
        <div class="card-body">
          <p class="text-muted mb-3">Sinistros, multas, manutenções/OS, cobranças, reservas, substituições, retornos, entregas, acessórios e competências deste contrato.</p>
          <div class="d-flex flex-wrap gap-2 mb-3">
            <button type="button" class="btn mgmt-btn mgmt-btn-primary" data-tone="indigo" (click)="navigateOperational('operacional')">
              <i class="fas fa-chart-pie"></i>
              <span>Dashboard operacional</span>
            </button>
          </div>
          <div class="mgmt-actions">
            <button type="button" class="btn mgmt-btn" data-tone="amber" (click)="navigateOperational('manutencoes')">
              <i class="fas fa-wrench"></i>
              <span>Manutenções / OS</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="rose" (click)="navigateOperational('sinistros')">
              <i class="fas fa-car-crash"></i>
              <span>Sinistros</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="orange" (click)="navigateOperational('multas')">
              <i class="fas fa-gavel"></i>
              <span>Multas</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="violet" (click)="navigateOperational('cobrancas')">
              <i class="fas fa-file-invoice-dollar"></i>
              <span>Cobranças</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="violet" (click)="navigateOperational('faturas')">
              <i class="fas fa-file-invoice"></i>
              <span>Faturas</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="sky" (click)="navigateOperational('reservas')">
              <i class="fas fa-calendar-check"></i>
              <span>Reservas</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="teal" (click)="navigateOperational('substituicoes')">
              <i class="fas fa-exchange-alt"></i>
              <span>Substituições</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="slate" (click)="navigateOperational('retornos')">
              <i class="fas fa-undo"></i>
              <span>Retornos</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="cyan" (click)="navigateOperational('entregas')">
              <i class="fas fa-truck"></i>
              <span>Entregas</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="indigo" (click)="navigateOperational('acessorios')">
              <i class="fas fa-toolbox"></i>
              <span>Acessórios</span>
            </button>
            <button type="button" class="btn mgmt-btn" data-tone="green" (click)="navigateOperational('pagamentos')">
              <i class="fas fa-money-check-alt"></i>
              <span>Pagamentos</span>
            </button>
          </div>
        </div>
      </div>

      <!-- Documentos -->
      <div class="card mb-4 section-documents" id="documentos-contrato">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-file-pdf me-2"></i>
            Documentos
          </h3>
        </div>
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-6" *ngIf="contract?.fichaCadastralUrl">
              <label class="form-label">Ficha Cadastral</label>
              <p class="form-control-plaintext">
                <button class="btn btn-sm btn-outline-primary" (click)="contract && downloadDocument(contract.fichaCadastralUrl)">
                  <i class="fas fa-download me-2"></i>
                  Baixar Ficha Cadastral
                </button>
              </p>
            </div>
            <!-- Documento do contrato: com URL = baixar; sem URL = pendente + upload -->
            <div class="col-12" *ngIf="hasContractDocument">
              <div class="doc-modern-panel">
                <div class="doc-modern-title">Contrato B2B</div>
                <p class="doc-modern-subtitle mb-0">Documento principal assinado.</p>

                <div class="doc-modern-actions">
                  <button
                    type="button"
                    class="btn doc-btn doc-btn-download"
                    (click)="contract && downloadDocument(contract.contractDocumentUrl)">
                    <i class="fas fa-download me-2"></i>
                    Baixar
                  </button>

                  <button
                    type="button"
                    class="btn doc-btn doc-btn-view"
                    (click)="viewContractDocument()">
                    <i class="fas fa-eye me-2"></i>
                    Visualizar
                  </button>

                  <button
                    type="button"
                    class="btn doc-btn doc-btn-sign"
                    (click)="openB2bSignModal()">
                    <i class="fas fa-signature me-2"></i>
                    Assinar
                  </button>
                </div>
              </div>
            </div>
            <div class="col-12" *ngIf="!hasContractDocument">
              <div class="doc-upload-shell">
                <div class="doc-upload-header">
                  <h5 class="mb-1">
                    <i class="fas fa-file-contract me-2"></i>
                    Documentos do Contrato B2B
                  </h5>
                  <p class="mb-0 text-muted">Gerencie arquivo e assinatura deste contrato.</p>
                </div>

                <div class="doc-upload-status">
                  <span class="doc-status-badge">
                    <i class="fas fa-clock me-1"></i>
                    Pendente
                  </span>
                  <span class="text-muted small">
                    Faça upload do documento assinado do contrato B2B (PDF, DOC, DOCX).
                  </span>
                </div>

                <input
                  type="file"
                  [id]="documentInputId"
                  class="d-none"
                  accept=".pdf,.doc,.docx"
                  (change)="onDocumentFileSelected($event)">
                <label [for]="documentInputId" class="doc-dropzone">
                  <div *ngIf="selectedDocumentFile; else emptyDropzone" class="doc-dropzone-filled">
                    <div class="doc-dropzone-icon success">
                      <i class="fas fa-file-check"></i>
                    </div>
                    <p class="doc-file-name mb-1">{{ selectedDocumentFile.name }}</p>
                    <small class="text-muted">Clique para selecionar outro arquivo</small>
                  </div>
                  <ng-template #emptyDropzone>
                    <div class="doc-dropzone-icon">
                      <i class="fas fa-cloud-upload-alt"></i>
                    </div>
                    <p class="mb-1 fw-semibold">Clique para selecionar o arquivo do contrato</p>
                    <small class="text-muted">Formatos aceitos: PDF, DOC, DOCX</small>
                  </ng-template>
                </label>

                <div class="doc-upload-footer">
                  <div class="d-flex flex-wrap align-items-center gap-2">
                    <button
                      type="button"
                      class="btn btn-sm btn-outline-primary"
                      [disabled]="!selectedDocumentFile || isUploadingDocument || !isDocxSelected"
                      (click)="openDocumentEditor()">
                      <i class="fas fa-pen-to-square me-1"></i>
                      Abrir para editar
                    </button>
                  </div>
                  <button
                    type="button"
                    class="btn btn-sm btn-dark"
                    [disabled]="!selectedDocumentFile || isUploadingDocument"
                    (click)="uploadContractDocument()">
                    <span *ngIf="isUploadingDocument" class="spinner-border spinner-border-sm me-1"></span>
                    <i *ngIf="!isUploadingDocument" class="fas fa-cloud-upload-alt me-1"></i>
                    {{ isUploadingDocument ? 'Enviando...' : 'Enviar documento' }}
                  </button>
                </div>
                <div class="small text-muted mt-2" *ngIf="selectedSignaturePosition">
                  Posição marcada: página {{ selectedSignaturePosition.page }} | X: {{ selectedSignaturePosition.x }} | Y: {{ selectedSignaturePosition.y }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <app-modal
        [isOpen]="showSignaturePositionModal"
        [title]="'Marcar Posição da Assinatura'"
        [size]="'lg'"
        [closable]="true"
        (close)="closeSignaturePositionModal()">
        <div class="signature-position-modal-body">
          <p class="text-muted mb-2">
            Clique no local da assinatura na prévia do documento (PDF ou DOCX) e ajuste o tamanho desejado.
          </p>
          <div class="row g-2 mb-2">
            <div class="col-md-6">
              <label class="form-label mb-1">Largura da assinatura (px)</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="signatureSizeWidth" min="80" max="500">
            </div>
            <div class="col-md-6">
              <label class="form-label mb-1">Altura de referência (px)</label>
              <input type="number" class="form-control form-control-sm" [(ngModel)]="signatureSizeHeight" min="30" max="300">
            </div>
          </div>
          <div class="alert alert-danger py-2 mb-2" *ngIf="signaturePreviewError">{{ signaturePreviewError }}</div>
          <div class="signature-preview-wrapper" *ngIf="!signaturePreviewError">
            <div class="signature-preview-loading" *ngIf="isRenderingSignaturePreview">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Renderizando documento...
            </div>
            <div class="signature-canvas-wrap" *ngIf="!isRenderingSignaturePreview && signatureModalMode === 'pdf'">
              <canvas #signaturePdfCanvas class="signature-pdf-canvas" (click)="onSignatureCanvasClick($event)"></canvas>
              <div class="signature-marker" *ngIf="signatureMarkerStyle"
                [style.left]="signatureMarkerStyle.left"
                [style.top]="signatureMarkerStyle.top"></div>
            </div>
            <div class="signature-docx-wrap" *ngIf="!isRenderingSignaturePreview && signatureModalMode === 'docx'">
              <div #docxPreviewContainer class="signature-docx-preview" (click)="onDocxPreviewClick($event)"></div>
              <div class="signature-marker" *ngIf="signatureMarkerStyle"
                [style.left]="signatureMarkerStyle.left"
                [style.top]="signatureMarkerStyle.top"></div>
            </div>
          </div>
        </div>
        <div slot="footer" class="d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-primary"
            [disabled]="!selectedSignaturePosition || isApplyingSignatureStamp || signatureModalMode !== 'pdf'"
            (click)="applySignatureStampToDocument()">
            <span *ngIf="isApplyingSignatureStamp" class="spinner-border spinner-border-sm me-1"></span>
            Aplicar assinatura no PDF
          </button>
          <button type="button" class="btn btn-secondary" (click)="closeSignaturePositionModal()">Fechar</button>
        </div>
      </app-modal>

      <app-modal
        [isOpen]="showDocumentEditorModal"
        [title]="'Editar documento DOCX'"
        [size]="'xl'"
        [closable]="true"
        (close)="closeDocumentEditor()">
        <div class="document-editor-modal-body">
          <div *ngIf="isLoadingDocumentEditor" class="text-muted">Carregando documento...</div>
          <div *ngIf="!isLoadingDocumentEditor && documentEditorError" class="alert alert-warning mb-0">
            {{ documentEditorError }}
          </div>
          <textarea *ngIf="!isLoadingDocumentEditor && !documentEditorError" id="b2bDocxEditor"></textarea>
        </div>
        <div slot="footer" class="d-flex justify-content-end gap-2">
          <button
            type="button"
            class="btn btn-outline-primary"
            [disabled]="isLoadingDocumentEditor || !!documentEditorError"
            (click)="insertDigitalSignatureAtCursor()">
            <i class="fas fa-stamp me-1"></i>
            Inserir "Assinatura Digital"
          </button>
          <button type="button" class="btn btn-secondary" (click)="closeDocumentEditor()">Cancelar</button>
          <button type="button" class="btn btn-success" [disabled]="isSavingDocumentEditor || isLoadingDocumentEditor" (click)="saveDocumentEditor()">
            <span *ngIf="isSavingDocumentEditor" class="spinner-border spinner-border-sm me-1"></span>
            {{ isSavingDocumentEditor ? 'Salvando...' : 'Salvar edição' }}
          </button>
        </div>
      </app-modal>

      <app-modal
        [isOpen]="showDocumentViewer"
        [title]="'Visualizar documento do contrato'"
        [size]="'xl'"
        [closable]="true"
        (close)="closeDocumentViewer()">
        <div class="d-flex justify-content-end mb-2">
          <button type="button" class="btn btn-sm btn-outline-secondary" (click)="openSelectedDocumentInNewTab()">
            <i class="fas fa-external-link-alt me-1"></i>
            Abrir em nova aba
          </button>
        </div>
        <div style="height: 75vh;">
          <div *ngIf="isLoadingDocumentViewer" class="text-muted d-flex align-items-center justify-content-center h-100">
            <span class="spinner-border spinner-border-sm me-2"></span>
            Carregando visualização...
          </div>
          <div *ngIf="!isLoadingDocumentViewer && documentViewerError" class="alert alert-warning">
            {{ documentViewerError }}
          </div>
          <div *ngIf="!isLoadingDocumentViewer && !documentViewerError && documentViewerType === 'docx'"
               #documentViewerDocxContainer
               class="signature-docx-wrap h-100"></div>
          <iframe
            *ngIf="!isLoadingDocumentViewer && !documentViewerError && documentViewerType === 'iframe'"
            [src]="documentViewerUrl"
            style="width: 100%; height: 100%; border: none;"
            title="Visualização do documento">
          </iframe>
        </div>
      </app-modal>

      <app-modal
        [isOpen]="showB2bSignModal"
        [title]="'Assinar documento B2B'"
        [size]="'lg'"
        [closable]="true"
        (close)="closeB2bSignModal()">
        <p class="text-muted mb-2">Desenhe a assinatura no quadro abaixo.</p>
        <div class="signature-preview-wrapper">
          <canvas #b2bSignatureCanvas class="signature-pdf-canvas"></canvas>
        </div>
        <div slot="footer" class="d-flex justify-content-end gap-2">
          <button type="button" class="btn btn-outline-secondary" (click)="clearB2bSignatureCanvas()">Limpar</button>
          <button type="button" class="btn btn-success" [disabled]="isSigningB2bDocument" (click)="signCurrentB2bDocument()">
            <span *ngIf="isSigningB2bDocument" class="spinner-border spinner-border-sm me-1"></span>
            {{ isSigningB2bDocument ? 'Assinando...' : 'Assinar e salvar versão' }}
          </button>
        </div>
      </app-modal>

      <!-- Tabela de Pedidos (sempre visível na visualização do contrato) -->
      <div class="card mb-4 section-items-table" id="pedidos-contrato" *ngIf="showItemsTable">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
            <div>
              <h5 class="mb-1">
                <i class="fas fa-list me-2 text-primary"></i>
                Pedidos do Contrato
              </h5>
              <p class="text-muted mb-0 small">Prévia paginada. Para focar só nesta tabela, abra a tela completa.</p>
            </div>
            <div class="d-flex flex-wrap gap-2">
              <app-button
                text="Abrir tabela de pedidos"
                color="var(--primary-color)"
                height="40px"
                (buttonClick)="navigateToItemsList()">
                <i class="fas fa-table me-2"></i>
              </app-button>
              <app-button
                *appHasPermission="'B2BContracts.Edit'"
                text="Novo Pedido"
                color="var(--success-color)"
                height="40px"
                (buttonClick)="openAddItemModal()">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </div>
          <div *ngIf="totalItems > 0 || isLoadingItems || itemsSearchTerm || (items && items.length > 0); else emptyItems">
            <app-table
              [title]="'Lista de Pedidos (' + totalItems + ')'"
              [data]="items"
              [columns]="itemsColumns"
              [loading]="isLoadingItems"
              [searchRight]="true"
              [clickable]="false"
              [actions]="itemsActions"
              [showSearch]="true"
              [searchPlaceholder]="'Pesquisar número do pedido ou placa...'"
              [itemsPerPage]="itemsPageSize"
              [totalItemsFromBackend]="totalItems"
              [currentPageFromBackend]="itemsPage"
              [totalPagesFromBackend]="itemsTotalPages"
              [disablePagination]="false"
              (searchChange)="onItemsSearchChange($event)"
              (actionClick)="onItemActionClick($event)"
              (pageChange)="onItemsPageChange($event)"
              (pageSizeChange)="onItemsPageSizeChange($event)">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="totalItems === 0"
                (buttonClick)="exportItemsExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
          </div>

          <ng-template #emptyItems>
            <div class="empty-state text-center py-5">
              <i class="fas fa-list fa-3x text-muted mb-3"></i>
              <h4>Nenhum pedido encontrado</h4>
              <p class="text-muted">Este contrato não possui pedidos cadastrados.</p>
              <app-button *appHasPermission="'B2BContracts.Edit'" text="Novo Pedido" color="var(--success-color)" height="40px" (buttonClick)="openAddItemModal()">
                <i class="fas fa-plus me-2"></i>
              </app-button>
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Cláusulas e Condições -->
      <div class="card mb-4 section-clauses" *ngIf="contract?.clausesAndConditions">
        <div class="card-header text-white">
          <h3 class="mb-0">
            <i class="fas fa-file-alt me-2"></i>
            Cláusulas e Condições
          </h3>
        </div>
        <div class="card-body">
          <div class="clauses-content">
            <pre class="mb-0">{{ contract?.clausesAndConditions }}</pre>
          </div>
        </div>
      </div>

      <!-- Situação Financeira do contrato — último bloco da visualização -->
      <div class="card mb-4 section-receivables-table" id="financeiro-contrato">
        <div class="card-body">
          <div *ngIf="isLoadingReceivables || (receivables && receivables.length > 0)">
            <app-table
              [title]="'Situação Financeira do Contrato (' + receivablesTotal + ')'"
              [data]="receivables"
              [columns]="receivablesColumns"
              [loading]="isLoadingReceivables"
              [searchRight]="true"
              [clickable]="false"
              [showSearch]="true"
              [searchPlaceholder]="'Pesquisar documento, descrição ou status...'"
              [disablePagination]="true">
              <app-button
                table-header-action
                text="Exportar Excel"
                color="var(--success-color)"
                height="36px"
                [disabled]="!receivables || receivables.length === 0"
                (buttonClick)="exportReceivablesExcel()">
                <i class="fas fa-file-excel me-2"></i>
              </app-button>
            </app-table>
          </div>

          <div *ngIf="!isLoadingReceivables && (!receivables || receivables.length === 0)" class="empty-state text-center py-4">
            <i class="fas fa-file-invoice-dollar fa-2x text-muted mb-2"></i>
            <h5>Nenhum título na situação financeira</h5>
            <p class="text-muted mb-0">As parcelas e cobranças deste contrato ainda não foram geradas.</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div *ngIf="!isLoading && !contract" class="empty-state">
      <i class="fas fa-file-contract"></i>
      <h3>Contrato não encontrado</h3>
      <p>O contrato solicitado não foi encontrado ou não está mais disponível.</p>
      <button class="btn btn-primary" (click)="navigateBack()">
        <i class="fas fa-arrow-left me-2"></i>
        Voltar para Lista
      </button>
      </div>
    </div>

    <!-- Modal de Visualizar Item -->
    <app-modal
      [isOpen]="showViewItemModal"
      [title]="'Visualizar Item do Contrato'"
      [size]="'xl'"
      (close)="closeViewItemModal()">
      
      <app-loading [show]="isLoadingItem" message="Carregando item..."></app-loading>
      
      <div *ngIf="!isLoadingItem && selectedItem" class="item-view-content">
        <div class="row g-3">
          <!-- Informações do Item -->
          <div class="col-12">
            <h5 class="mb-3">
              <i class="fas fa-info-circle me-2"></i>
              Informações do Item
            </h5>
          </div>

          <div class="col-md-6">
            <label class="form-label">Número do Item</label>
            <p class="form-control-plaintext">{{ selectedItem.itemNumber }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Tipo de Moto</label>
            <p class="form-control-plaintext">{{ selectedItem.motorcycleType }}</p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Quantidade</label>
            <p class="form-control-plaintext">{{ selectedItem.quantity }}</p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Valor Unitário</label>
            <p class="form-control-plaintext mb-0">
              <app-sensitive-currency [displayOnly]="true" [amount]="selectedItem.unitValue"></app-sensitive-currency>
            </p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Status</label>
            <p class="form-control-plaintext">
              <span class="badge" [ngClass]="getItemStatusClass(selectedItem.status)">
                {{ selectedItem.status }}
              </span>
            </p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Tipo de Pagamento</label>
            <p class="form-control-plaintext">{{ selectedItem.paymentType }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Número de Parcelas</label>
            <p class="form-control-plaintext">{{ selectedItem.installmentCount }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Tipo de Contrato</label>
            <p class="form-control-plaintext">{{ selectedItem.contractType }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Tipo de Entrega</label>
            <p class="form-control-plaintext">{{ selectedItem.deliveryType }}</p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Estado</label>
            <p class="form-control-plaintext">{{ selectedItem.state }}</p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Cidade</label>
            <p class="form-control-plaintext">{{ selectedItem.city }}</p>
          </div>
          <div class="col-md-4">
            <label class="form-label">Rua / número</label>
            <p class="form-control-plaintext">{{ selectedItem.pole }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Data de Entrega</label>
            <p class="form-control-plaintext">{{ formatDate(selectedItem.deliveryDate) }}</p>
          </div>
          <div class="col-md-6" *ngIf="selectedItem.returnDate">
            <label class="form-label">Data de Devolução</label>
            <p class="form-control-plaintext">{{ formatDate(selectedItem.returnDate) }}</p>
          </div>
          <div class="col-md-6">
            <label class="form-label">Possui Baú</label>
            <p class="form-control-plaintext">
              <span class="badge" [ngClass]="selectedItem.hasBox ? 'badge-success' : 'badge-secondary'">
                {{ selectedItem.hasBox ? 'Sim' : 'Não' }}
              </span>
            </p>
          </div>
          <div class="col-md-6" *ngIf="selectedItem.trackerType">
            <label class="form-label">Tipo de Rastreador</label>
            <p class="form-control-plaintext">{{ selectedItem.trackerType }}</p>
          </div>
          <div class="col-12" *ngIf="selectedItem.accessoriesDescription">
            <label class="form-label">Descrição de Acessórios</label>
            <p class="form-control-plaintext">{{ selectedItem.accessoriesDescription }}</p>
          </div>

          <!-- Informações do Veículo -->
          <div class="col-12" *ngIf="selectedItem.vehicleSnapshot">
            <hr>
            <h5 class="mb-3">
              <i class="fas fa-motorcycle me-2"></i>
              Informações do Veículo
            </h5>
          </div>

          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Placa</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.plate }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Marca</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.brand }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Modelo</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.model }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Ano</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.year }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Cor</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.color }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">RENAVAM</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.renavam }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Chassi</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.chassis }}</p>
          </div>
          <div class="col-md-3" *ngIf="selectedItem.vehicleSnapshot">
            <label class="form-label">Quilometragem Atual</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.currentKm | number }} km</p>
          </div>
          <div class="col-12" *ngIf="selectedItem.vehicleSnapshot?.inspectionNotes">
            <label class="form-label">Observações da Vistoria</label>
            <p class="form-control-plaintext">{{ selectedItem.vehicleSnapshot.inspectionNotes }}</p>
          </div>
        </div>
      </div>

      <div slot="footer" class="modal-footer-buttons">
        <button type="button" class="btn btn-secondary" (click)="closeViewItemModal()">
          Fechar
        </button>
        <button type="button" class="btn btn-primary" (click)="editItem(selectedItem?.id)" *ngIf="selectedItem">
          <i class="fas fa-edit me-2"></i>
          Editar Item
        </button>
      </div>
    </app-modal>

    <!-- Modal de Editar Item -->
    <app-modal
      [isOpen]="showEditItemModal"
      [title]="'Editar Item do Contrato'"
      [size]="'xl'"
      (close)="closeEditItemModal()">
      
      <app-loading [show]="isLoadingItem" message="Carregando dados do item..."></app-loading>
      
      <form [formGroup]="editItemForm" (ngSubmit)="onSubmitEditItem()" *ngIf="!isLoadingItem">
        <div class="row g-3">
          <!-- Informações do Item -->
          <div class="col-12">
            <h5 class="mb-3">
              <i class="fas fa-info-circle me-2"></i>
              Informações do Item
            </h5>
          </div>

          <div class="col-md-6">
            <label class="form-label">Tipo de Moto <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="motorcycleType"
              [class.is-invalid]="isEditFieldInvalid('motorcycleType')"
              placeholder="Ex: Yamaha Factor 150">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('motorcycleType')">
              {{ getEditFieldError('motorcycleType') }}
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Quantidade <span class="text-danger">*</span></label>
            <input
              type="number"
              class="form-control"
              formControlName="quantity"
              [class.is-invalid]="isEditFieldInvalid('quantity')"
              min="1">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('quantity')">
              {{ getEditFieldError('quantity') }}
            </div>
          </div>

          <div class="col-md-3">
            <label class="form-label">Valor Unitário <span class="text-danger">*</span></label>
            <app-sensitive-currency
              formControlName="unitValue"
              [invalid]="isEditFieldInvalid('unitValue')"
              [min]="0"
              step="0.01">
            </app-sensitive-currency>
            <div class="invalid-feedback d-block" *ngIf="isEditFieldInvalid('unitValue')">
              {{ getEditFieldError('unitValue') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Tipo de Pagamento <span class="text-danger">*</span></label>
            <select
              class="form-control"
              formControlName="paymentType"
              [class.is-invalid]="isEditFieldInvalid('paymentType')">
              <option *ngFor="let type of paymentTypeOptions" [value]="type">{{ type }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('paymentType')">
              {{ getEditFieldError('paymentType') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Número de Parcelas <span class="text-danger">*</span></label>
            <input
              type="number"
              class="form-control"
              formControlName="installmentCount"
              [class.is-invalid]="isEditFieldInvalid('installmentCount')"
              min="1">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('installmentCount')">
              {{ getEditFieldError('installmentCount') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Tipo de Contrato <span class="text-danger">*</span></label>
            <select
              class="form-control"
              formControlName="contractType"
              [class.is-invalid]="isEditFieldInvalid('contractType')">
              <option *ngFor="let type of contractTypeOptions" [value]="type">{{ type }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('contractType')">
              {{ getEditFieldError('contractType') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Tipo de Entrega <span class="text-danger">*</span></label>
            <select
              class="form-control"
              formControlName="deliveryType"
              [class.is-invalid]="isEditFieldInvalid('deliveryType')">
              <option *ngFor="let type of deliveryTypeOptions" [value]="type">{{ type }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('deliveryType')">
              {{ getEditFieldError('deliveryType') }}
            </div>
          </div>

          <div class="col-12" *ngIf="isEditEntregaDelivery">
            <p class="text-muted small mb-2">Informe o endereço de entrega.</p>
          </div>

          <div class="col-md-4" *ngIf="isEditEntregaDelivery">
            <label class="form-label">Estado <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="state"
              [class.is-invalid]="isEditFieldInvalid('state')"
              placeholder="Ex: SP">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('state')">
              {{ getEditFieldError('state') }}
            </div>
          </div>

          <div class="col-md-4" *ngIf="isEditEntregaDelivery">
            <label class="form-label">Cidade <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="city"
              [class.is-invalid]="isEditFieldInvalid('city')"
              placeholder="Ex: São Paulo">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('city')">
              {{ getEditFieldError('city') }}
            </div>
          </div>

          <div class="col-md-4" *ngIf="isEditEntregaDelivery">
            <label class="form-label">Rua / número <span class="text-danger">*</span></label>
            <input
              type="text"
              class="form-control"
              formControlName="pole"
              [class.is-invalid]="isEditFieldInvalid('pole')"
              placeholder="Ex: Av. Paulista, 1000">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('pole')">
              {{ getEditFieldError('pole') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Data de Entrega <span class="text-danger">*</span></label>
            <input
              type="date"
              class="form-control"
              formControlName="deliveryDate"
              [class.is-invalid]="isEditFieldInvalid('deliveryDate')">
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('deliveryDate')">
              {{ getEditFieldError('deliveryDate') }}
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Data de Devolução</label>
            <input
              type="date"
              class="form-control"
              formControlName="returnDate">
          </div>

          <div class="col-md-6">
            <label class="form-label">Tipo de Rastreador</label>
            <input
              type="text"
              class="form-control"
              formControlName="trackerType"
              placeholder="Ex: GPS Tracker Pro">
          </div>

          <div class="col-md-6">
            <label class="form-label">Possui Baú</label>
            <div class="form-check mt-2">
              <input
                type="checkbox"
                class="form-check-input"
                formControlName="hasBox"
                id="editHasBox">
              <label class="form-check-label" for="editHasBox">
                Sim
              </label>
            </div>
          </div>

          <div class="col-md-6">
            <label class="form-label">Status <span class="text-danger">*</span></label>
            <select
              class="form-control"
              formControlName="status"
              [class.is-invalid]="isEditFieldInvalid('status')">
              <option *ngFor="let status of statusOptions" [value]="status">{{ status }}</option>
            </select>
            <div class="invalid-feedback" *ngIf="isEditFieldInvalid('status')">
              {{ getEditFieldError('status') }}
            </div>
          </div>

          <div class="col-12">
            <label class="form-label">Descrição de Acessórios</label>
            <textarea
              class="form-control"
              formControlName="accessoriesDescription"
              rows="3"
              placeholder="Ex: Baú de 45L, GPS, Kit de segurança"></textarea>
          </div>
        </div>

        <div slot="footer" class="modal-footer-buttons">
          <button type="button" class="btn btn-secondary" (click)="closeEditItemModal()" [disabled]="isSubmitting">
            Cancelar
          </button>
          <button type="submit" class="btn btn-primary" [disabled]="editItemForm.invalid || isSubmitting">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm me-2"></span>
            <i *ngIf="!isSubmitting" class="fas fa-save me-2"></i>
            {{ isSubmitting ? 'Salvando...' : 'Salvar Alterações' }}
          </button>
        </div>
      </form>
    </app-modal>

    <app-modal
      [isOpen]="showCancelContractModal"
      [title]="'Cancelar Contrato B2B'"
      [size]="'md'"
      [closable]="true"
      (close)="closeCancelContractModal()">

      <div class="py-2">
        <div class="alert alert-warning mb-3">
          <i class="fa-solid fa-exclamation-triangle me-2"></i>
          O contrato será cancelado e as cobranças pendentes (boletos em aberto) serão canceladas no Asaas, como na lista de contratos.
        </div>

        <div class="mb-3">
          <label for="b2bViewCancelReasonCode" class="form-label">
            Motivo do cancelamento <span class="text-danger">*</span>
          </label>
          <select
            id="b2bViewCancelReasonCode"
            class="form-select"
            [(ngModel)]="cancelReasonCode"
            name="b2bViewCancelReasonCode">
            <option [ngValue]="''">Selecione um motivo</option>
            <option *ngFor="let o of contractCancelReasonOptions" [ngValue]="o.code">{{ o.label }}</option>
          </select>
          <small class="text-muted d-block mt-1">O texto é gravado nas observações do contrato B2B (formato de cancelamento).</small>
        </div>

        <p class="mb-0">
          <strong>Confirma o cancelamento do contrato {{ contract?.contractNumber || contractId }}?</strong>
        </p>
      </div>

      <div slot="footer" class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="closeCancelContractModal()" [disabled]="isCancellingContract">
          Fechar
        </button>
        <button type="button" class="btn btn-danger" (click)="confirmCancelContract()" [disabled]="isCancellingContract">
          <span *ngIf="isCancellingContract" class="spinner-border spinner-border-sm me-2"></span>
          Confirmar Cancelamento
        </button>
      </div>
    </app-modal>
  </app-side-menu>

